import { Card, Skeleton } from 'antd';
import React from 'react';

const MediaCardSkeleton = ({ size = 'large' }) => {
  const isLarge = size === 'large';

  return (
    <Card
      hoverable={false}
      cover={
        <Skeleton.Image
          active
          style={{
            width: '100%',
            height: isLarge ? 200 : 150,
          }}
        />
      }
      styles={{
        body: { padding: isLarge ? '12px' : '8px' },
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <Skeleton.Input
          active
          size={isLarge ? 'default' : 'small'}
          style={{ width: '100%', height: isLarge ? 22 : 18 }}
        />
        <Skeleton.Button
          active
          size="small"
          style={{ width: 80, height: 22 }}
        />
      </div>
    </Card>
  );
};

export default MediaCardSkeleton;
